import { Branch, Institute } from '../../../redux/coachingCenter/types'
import { DropdownListProps } from '../../../components/EditableDropdown/typings'
import { Batch } from '../../../redux/batch/types'

export const getInstituteDropdown = (
  institutes: Array<Institute>
): Array<DropdownListProps> => {
  const institutesDropdown = institutes.map((institute: Institute) => ({
    id: institute?.id,
    name: institute?.coachingCentreName
  }))
  return institutesDropdown
}

export const getBranchDropDown = (
  branches: Array<Branch>
): Array<DropdownListProps> => {
  const branchDropdown = branches.map((branch: Branch) => ({
    id: branch?.id,
    name: branch?.branchName
  }))
  return branchDropdown
}

export const getBatchDropdown = (
  batches: Array<Batch>
): Array<DropdownListProps> => {
  const batchDropdown = batches.map((batch: Batch) => ({
    id: batch?.id,
    name: batch?.batchName
  }))
  return batchDropdown
}

export const getSelectedInstitute = (
  institutes: Array<Institute>,
  id: string
): DropdownListProps | null => {
  const selectedInstitute = institutes.filter(
    (institute: Institute) => institute?.id === id
  )
  return selectedInstitute?.length
    ? {
      id: selectedInstitute[0]?.id,
      name: selectedInstitute[0]?.coachingCentreName
    }
    : null
}

export const getSelectedBranch = (
  branches: Array<Branch>,
  id: string
): DropdownListProps | null => {
  const selectedBranch = branches.filter((branch: Branch) => branch?.id === id)
  return selectedBranch?.length
    ? {
      id: selectedBranch[0]?.id,
      name: selectedBranch[0]?.branchName
    }
    : null
}

export const getSelectedBatch = (
  batches: Array<Batch>,
  id: string
): DropdownListProps | null => {
  const selectedBatch = batches.filter((batch: Batch) => batch?.id === id)
  return selectedBatch?.length
    ? {
      id: selectedBatch[0]?.id,
      name: selectedBatch[0]?.batchName
    }
    : null
}
